export * from './installation-customer-attendees.menu';
export * from './signature.menu';
export * from './edit-file.menu';
export * from './observation.menu';
export * from './edit-observation.menu';
export * from './edit-discussion.menu';
export * from './edit-fileandsuggestions.menu';
export * from './file-reader.menu';
export * from './filemanager.menu';
export * from './base.menu';
export * from './edit-upgrades.menu';
